<template>
  <main-farme>
    <div slot="aside-left">
      <!-- :DialogFlag.sync="shwoContentDialogProp" -->
      <!-- 迹点基本信息：名称、poi、主图 简介 分类、标签-->
      <el-card shadow="never"
               class="card-header-style"
               :body-style="{ padding: '15px' }"
               style="height: auto; width: 400px; border-radius: 5px">
        <div slot="header"
             class="header-product-title">
          {{ traver_title }}
          <span style="float:right">id:{{traver_id}}</span>
        </div>
        <show-image :default_image="traver_cover"
                    @getCroperImageURl="getImageURl"
                    imageWidth="370px"
                    imageHeight="240px"
                    :limitSize="8"
                    :fixedRatio="[370, 240]"
                    :image_type_name="'traver_point_cover_id_'+traver_id"></show-image>
        <!-- <div style="height: 100px"></div> -->
        <!-- 名称 -->
        <input-modify :showEditorButtom="true"
                      :title="traver_title"
                      @saveInputContent="changeTraverTitle"></input-modify>

        <!-- 电话 -->
        <input-modify :showEditorButtom="true"
                      :title="traver_tell"
                      @saveInputContent="changeTraverTitle"></input-modify>

        <!-- 官网链接：可修改 -->
        <div> 官网：
          <el-link>
          </el-link>
        </div>

        <el-divider></el-divider>
        <!-- 分类 -->
        <el-cascader v-model="traver_class"
                     size="mini"
                     style="width:100%"
                     :options="traverClassOptions"
                     :props="traverClassProps"
                     @change="traverClassChange"></el-cascader>

        <!-- 标签 -->
        <!-- <div class="content-left-info">
          <b>标签:</b>
          {{ traver_tag }}
        </div> -->
      </el-card>
      <!-- -------------------------------------地图选点------------------------------- -->
      <el-card shadow="never"
               style="margin-top: 10px;">
        <!-- 定位：选择/ 添加/ 展示 -->
        <input-modify title="关联定位"></input-modify>

        <!-- 展示 地图定位 v-if="showLocationOnMap"-->
        <div style="position:relative">
          <show-location-on-map ref="showLocationOnMap"></show-location-on-map>
          <!-- 修改按钮 -->
          <el-button class="check-traver-point-band-location"
                     size="mini"
                     type="primary"
                     @click="openSeleceOrAddPOI">绑定定位</el-button>
        </div>
        <!-- 添加和修改 坐标的页面 -->
        <!-- <div v-if="!showLocationOnMap">

        </div> -->

        <el-dialog :visible.sync="showLocationOnMap"
                   width="50%">
          <select-or-add-poi-list @submitPoi="bandNewPoi"
                                  @closeSubmitPOI="closeSubmitPOI"
                                  :proplat="lat"
                                  :proplng="lng"></select-or-add-poi-list>
        </el-dialog>

      </el-card>
      <!-- -------------------------------------更新记录--------------------------------- -->
      <el-card shadow="never"
               class="card-header-style"
               style="margin-top: 10px; width: 400px; border-radius: 5px">
        <div class="content-left-info">
          <b>更新记录：</b>
        </div>
      </el-card>
    </div>

    <!-- ------------------------------- 右侧内容 编辑区 ------------------------------- -->

    <div slot="main">
      <el-card shadow="never"
               style="margin-bottom: 20px">
        <!-- 页头 -->
        <div class="page-header-button">详情</div>

        <el-divider></el-divider>
        <!-- 简介 -->
        <editor title="简介"
                :upLoadImgAddress="`${$ip}/add_image?key_name=traver_point_introduce_${this.traver_id}`"
                :show_content="traver_introduce"
                @save="saveTraverInfroduce"></editor>
      </el-card>
      <!-- -----------营业时间----------- -->
      <el-card shadow="never"
               style="margin-bottom: 20px">
        <!-- 关于时间的注意事项，温馨提示 -->
        <div style="margin-bottom:50px">
          <editor title="开放/营业时间说明："
                  :show_content="runnintTimeInfor"
                  @save="saveTimeInfor"></editor>
        </div>
        <input-modify title="选项"></input-modify>

        <!-- 时间日期选择器：星期、日期、营业时间段 -->
        <select-date-type ref="select_date_area"
                          :showWeekOrDate="showWeekOrDate"
                          :checkedWeekList="checkedWeekList"
                          @confirmSelectDate="confirmSelectDate"
                          @selectAllWeek="selectAllWeek"
                          @handleCheckedWeekChange="handleCheckedWeekChange"
                          @addRunningTime="addRunningTime"
                          @removeTime="removeTime"></select-date-type>

        <!-- 是否营业 -->
        <div style="margin-top:20px;text-align:right">
          <el-switch v-model="opening"
                     @change="openOrClose"
                     inactive-text="歇业"
                     active-text="营业"
                     active-color="#ff4949"
                     inactive-color="">
          </el-switch>
        </div>
      </el-card>
      <!-- ----------------------------注意事项---------------------------- -->
      <el-card shadow="never"
               style="margin-bottom: 20px">
        <editor title="注意事项\门票说明\预定说明等信息"
                :show_content="remark"
                :upLoadImgAddress="`${$ip}/add_image?key_name=traver_attention_introduce_${this.traver_id}`"
                @save="saveTraverAttention"></editor>
      </el-card>
      <!-- ----------------------------绑定关联内容---------------------------- -->
      <select-and-search-content :show.sync="showContentSelect"
                                 ref="select_and_search_content"
                                 @bandTraverContent="bandTraverContent"></select-and-search-content>
      <el-card shadow="never"
               style="margin-bottom: 20px;">
        <!-- 【标题】内容：多个 -->
        <title-and-button title="关联的内容"
                          @titleButtonClick="clickBandContent"
                          buttonName="关联内容"></title-and-button>
        <!-- 显示绑定的内容：图文、视频、音频 -->
        <div style="margin-top:20px"></div>
        <card-check-list :cardList="bandContentList"
                         :showUpdate="false"
                         :showDest="false"
                         :showButton="false"
                         :showMiniTitle="false"></card-check-list>
      </el-card>
      <!-- ---------------------------- 推荐组 ----------------------------  -->

      <el-card shadow="never"
               style="margin-bottom: 20px">
        <title-and-button title="周边推荐"
                          @titleButtonClick="clickAddRecommand"
                          buttonName="添加推荐"></title-and-button>
        <div style="margin-top:20px">
          <!-- 显示推荐列表组件 -->
          <div>
            <show-recommend-list :cardList="recommend_list"
                                 @deleteRecommendList="deleteRecommendList"
                                 @reNewRecommendList="reNewRecommendList"></show-recommend-list>
          </div>
          <!-- 添加推荐对话框 -->
          <select-and-band-traver-point ref="select_and_band_traver_point"
                                        buttonName="新建推荐"
                                        :latprop="this.lat"
                                        :lngprop="this.lng"
                                        :show.sync="bandTraverPointSelect"
                                        :inputRecommsndTitle="inputRecommsndTitle"
                                        :recommendTextArea="recommendTextArea"
                                        @creatNewTraverContent="creatNewTraverContent"
                                        @reNewTraverContent="reNewTraverContent"></select-and-band-traver-point>
        </div>

      </el-card>
      <!-- ----------------------------添加游玩指南：多个 对一---------------------------- -->
      <el-card shadow="never"
               style="margin-bottom: 20px;">
        <!-- 添加 -->
        <title-and-button title="游玩指南"
                          @titleButtonClick="clickAddGuide"
                          buttonName="添加游玩指南"></title-and-button>
        <!-- 导览模块 -->
        <card-list-full-image :cardList="guidList"
                              @checkCard="clickImageCard"></card-list-full-image>

      </el-card>

      <!-- ----------------------------产品：多个---------------------------- -->
      <el-card shadow="never"
               style="margin-bottom: 20px">

        <input-modify title="相关预定"></input-modify>
      </el-card>
    </div>
  </main-farme>
</template>

<script>
// 组件
import MainFrame from '../../components/common/main/MainFrame'
// import ShowImageAndUpLoad from '../../components/common/other/ShowImageAndUpLoad'
import ShowImageAndUpLoad from '../../components/common/other/UpLoadV2Croper'

import ShowLocationOnMap from '../../components/map/ShowLocationOnMap'

import ShowTitleAndModify from '../../components/common/modify/ShowTitleAndModify'
import TitleAndButton from '../../components/common/modify/TitleAndButton'

import SelectAndSearchContent from '../../components/common/select/SelectAndSearchContent'
import SelectAndBandTraverPoint from '../../components/common/select/SelectAndBandTraverPoint'
import SelectOrAddPoiList from '../../components/map/SelectOrAddPoiList'
import Editor from '../../components/common/modify/EditorV2ModifyMini'
import SelectDateType from '../../components/common/select/SelectDateType'

import CardMiniList from '../../components/common/cards/CardMiniList'
import CardListFullImage from '../../components/common/cards/CardListFullImage'
import ShowRecommendList from '../../components/common/cards/ShowRecommendList'
export default {
  name: 'check_traver_point',
  components: {
    'main-farme': MainFrame,
    'input-modify': ShowTitleAndModify,
    'title-and-button': TitleAndButton,
    ShowLocationOnMap,
    SelectOrAddPoiList,
    'show-image': ShowImageAndUpLoad,
    SelectDateType,
    Editor,
    'select-and-search-content': SelectAndSearchContent,
    'select-and-band-traver-point': SelectAndBandTraverPoint,
    'card-check-list': CardMiniList,
    ShowRecommendList, //show-recommend-list
    'card-list-full-image': CardListFullImage,
  },
  data() {
    return {
      source_map: '2',
      traver_id: null,
      traver_title: '', // 迹点名称
      traver_tell: '', //电话
      traver_class: '', //  迹点分类
      dest: '',
      traverClassOptions: [],
      traverClassProps: {
        emitPath: false,
        value: 'class_id',
        label: 'class_name',
        children: 'class_list',
      },
      // 坐标
      showLocationOnMap: false, // 显示修改定位
      lat: null,
      lng: null,
      traver_cover: '',
      traver_introduce: '', // 迹点介绍
      // 迹点所在目的地

      traver_tag: '', // 标签
      // 营业时间
      showWeekOrDate: 0,
      checkedWeekList: [],
      runnintTimeInfor: '',
      runTimeList: [],
      opening: true,
      open_introduce: '',
      remark: '', // 备注
      // 关联内容
      showContentSelect: false, // 显示绑定内容
      bandContentList: [],
      content_guide: '', // 迹点导览
      content_group: '', //内容组
      content_media: '', //媒体
      product: '',
      // 推荐 周边迹点
      bandTraverPointSelect: false, // 显示添加/推荐
      renewTraverPointSelect: false, // 修改推荐
      recommend_list: [],
      inputRecommsndTitle: '',
      recommendTextArea: '',
      bandTraverList: [], // 已绑定的traverid
      // 游玩指南
      guidList: [],
    }
  },
  mounted() {
    // console.log(this.$route.query.traver_id);
    this.traver_id = this.$route.query.traver_id
    this.getTraverClass()
    this.reNewTraverInfo()
  },
  methods: {
    // 更新信息
    reNewTraverInfo() {
      // 获取迹点基本信息
      this.getTraverInformation()
      // 获取迹点内容
      this.getBandContentList()
      // 获取迹点周边推荐
      this.getTraverContentGroup()
      // 获取迹点游玩指南
      this.getTraverContentGuide()
      // 获取迹点绑定产品
    },
    // 返回
    // goBack() {
    //   this.$router.go(-1)
    // },
    // 改变分类
    traverClassChange(val) {
      this.$http
        .get(
          `/traver/change_traver_point_class?traver_id=${this.traver_id}&traver_class=${val}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 获取全部分类
    getTraverClass() {
      this.$http.get('/traver/get_traver_class').then((res) => {
        if (res.data.errno == '0') {
          this.traverClassOptions = res.data.data
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    // ---------------------获取迹点基本信息-----------------------------
    getTraverInformation() {
      this.$http
        .get(
          `/traver/get_traver_point?traver_id=${this.traver_id}&source_map=${this.source_map}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.traver_title = res.data.data.traver_title
            this.traver_tell = res.data.data.traver_tell
            this.traver_cover = res.data.data.traver_cover
            this.traver_introduce = res.data.data.traver_info
            this.traver_class = res.data.data.traver_class
            this.dest = res.data.data.dest

            if (res.data.data.lat !== null) {
              this.lat = parseFloat(res.data.data.lat)
              this.lng = parseFloat(res.data.data.lng)
              this.$refs.showLocationOnMap.lat = this.lat
              this.$refs.showLocationOnMap.lng = this.lng
              this.$refs.showLocationOnMap.pointerOnMap()
            }
            // 营业时间说明
            this.runnintTimeInfor = res.data.data.open_introduce
            // 营业时间负值
            // console.log(this.$refs.select_date_area)
            this.showWeekOrDate = res.data.data.open_type
            // console.log(this.showWeekOrDate)
            // 营业日期根据类型赋值
            // console.log(res.data.data.open_value)
            if (res.data.data.open_type == '0') {
              this.checkedWeekList = res.data.data.open_value
            } else if (res.data.data.open_type == '1') {
              this.$refs.select_date_area.selectMulityDate =
                res.data.data.open_value
            }
            // 营业时间段
            this.$refs.select_date_area.runningTimeList =
              res.data.data.open_time
            // console.log(res)
            // 注意事项
            this.remark = res.data.data.traver_remark
            this.opening = res.data.data.opening
            this.open_type = res.data.data.opening
            this.open_introduce = res.data.data.open_introduce
            this.remark = res.data.data.traver_remark
          } else {
          }
        })
    },
    // ---------------------营业时间-----------------------
    // 营业说明
    saveTimeInfor(val) {
      // console.log(val)
      let item = {
        traver_id: this.traver_id,
        open_info: val,
      }
      this.$http.post(`/traver/open_time_info`, item).then((res) => {
        // console.log(res)
        if (res.data.errno == '0') {
          this.runnintTimeInfor = val
          this.$message({
            message: res.data.errmsg,
            type: 'success',
          })
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    // 歇业与营业
    openOrClose() {
      this.$http
        .get(
          `/traver/opening_or_close?traver_id=${this.traver_id}&opening=${this.opening}`
        )
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            // this.$message({
            //   message: res.data.errmsg,
            //   type: 'success',
            // })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 全选 星期
    selectAllWeek(val) {
      // 按星期营业：类型：0
      this.changeOpenTime(0, val)
    },
    // 选择 星期
    handleCheckedWeekChange(val) {
      // console.log(val)
      this.changeOpenTime(0, val)
    },
    // 选择日期
    confirmSelectDate(val) {
      // console.log(val)
      this.changeOpenTime(1, val)
    },
    // 添加营业时间
    addRunningTime(val) {
      // console.log(val)
      let time_list = []
      val.forEach((i) => {
        time_list.push(i[0] + '-' + i[1])
      })
      this.$http
        .get(
          `/traver/add_open_time?traver_id=${this.traver_id}&open_time=${time_list}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
          // console.log(res)
        })
    },
    // 减少营业时间
    removeTime(val) {
      let time_list = []
      val.forEach((i) => {
        time_list.push(i[0] + '-' + i[1])
      })

      this.$http
        .get(
          `/traver/add_open_time?traver_id=${this.traver_id}&open_time=${time_list}`
        )
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 保存迹点备注
    saveTraverAttention(val) {
      let item = {
        traver_id: this.traver_id,
        remark: val,
      }
      this.$http.post('/traver/traver_point_remark', item).then((res) => {
        // console.log(res)
        if (res.data.errno == '0') {
          this.remark = val
          this.$message({
            message: res.data.errmsg,
            type: 'success',
          })
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    // ----------------------------------------地图坐标----------------------------------------
    // 修改迹点定位按钮
    openSeleceOrAddPOI() {
      this.showLocationOnMap = true
    },
    // 提交定位
    closeSubmitPOI() {
      this.showLocationOnMap = !this.showLocationOnMap
      this.getTraverInformation()
    },
    // 绑定坐标
    bandNewPoi(value) {
      // console.log('绑定坐标')
      this.$http
        .get(
          `/band_poi_for_traver_point?poi_id=${value}&traver_id=${this.traver_id}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.getTraverInformation()
          } else if (res.data.errno == '4003') {
            this.$message({
              message: '该坐标点已存在，请改名，或在POI列表中选择',
              type: 'error',
            })
          }
        })

      this.showLocationOnMap = false
      this.lat = value.lat
      this.lng = value.lng
    },
    // 修改迹点名称
    changeTraverTitle(value) {
      if (value) {
        this.$http
          .get(
            `/traver/change_traver_title?traver_id=${this.traver_id}&traver_title=${value}`
          )
          .then((res) => {
            if (res.data.errno == '0') {
              this.getTraverInformation()
            }
          })
      } else {
        return
      }
    },
    // 修改迹点简介
    saveTraverInfroduce(value) {
      let info_item = {
        traver_id: this.traver_id,
        traver_introduce: value,
      }
      this.$http
        .post('/traver/change_traver_introduce', info_item)
        .then((res) => {
          if (res.data.errno == '0') {
            this.traver_introduce = value
          }
        })
    },
    // 修改封面图
    getImageURl(value) {
      console.log(value)
      this.traver_cover = value
      // 替换迹点封面图
      this.$http
        .get(
          `/traver/change_traver_cover?traver_id=${this.traver_id}&traver_cover=${value}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.traver_cover = value
            this.$message({
              type: 'success',
              message: res.data.errmsg,
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.errmsg,
            })
          }
        })
      // 更新页面封面图
    },
    // 更改营业日期 星期
    changeOpenTime(type, val) {
      // console.log(val)

      this.$confirm('此操作将修改该迹点营业时间, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .get(
              `/traver/opening_select_week_or_date?traver_id=${this.traver_id}&open_type=${type}&open_value=${val}`
            )
            .then((res) => {
              // console.log(res)
              if (res.data.errno == '0') {
              } else {
                this.$message({
                  message: res.data.errmsg,
                  type: 'error',
                })
              }
            })
        })
        .catch(() => {})
    },
    // -------------------------------------内容--------------------------------------
    // 绑定内容给迹点-- 打开页按钮
    clickBandContent() {
      this.showContentSelect = true
    },
    // 绑定内容给 迹点
    bandTraverContent(val) {
      this.$http
        .get(
          `/traver/band_content_to_traver?traver_id=${this.traver_id}&content_id=${val}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.getBandContentList()
            this.showContentSelect = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    //  -------------------------------周边推荐-----------------------------
    // 打开 新建推荐兑换框
    clickAddRecommand() {
      this.bandTraverPointSelect = true
    },
    // 创建推荐  API
    creatNewTraverContent(val) {
      val.traver_id = this.traver_id
      // console.log(val)
      this.$http.post('/traver/add_recommend_near_traver', val).then((res) => {
        // console.log(res)
        if (res.data.errno == '0') {
          this.$message({
            message: res.data.errmsg,
            type: 'success',
          })
          this.recommend_list = []
          // 执行更新，获取周边推荐列表
          this.getTraverContentGroup()
          this.bandTraverPointSelect = false
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    // 修改推荐组
    reNewRecommendList(val) {
      // console.log('这是啥', val)
      this.bandTraverPointSelect = true
      this.$refs.select_and_band_traver_point.recommend_id = val.id
      this.$refs.select_and_band_traver_point.input_recommsnd_title = val.name
      this.$refs.select_and_band_traver_point.recommend_text_area =
        val.introduce

      let check_list = []
      val.traver_point.forEach((item) => {
        check_list.push(item.traver_id)
      })
      this.$refs.select_and_band_traver_point.band_Traver_list = check_list
    },
    // 确认修改推荐组
    reNewTraverContent(val) {
      this.$http
        .post('/traver/renew_recommend_near_traver', val)
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            this.bandTraverPointSelect = false
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.recommend_list = []
            this.getTraverContentGroup()
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'errno',
            })
          }
        })
    },
    // 删除推荐组
    deleteRecommendList(val) {
      // console.log(val)
      this.$http
        .get(`/traver/delete_recommend_near_traver?recommend_id=${val}`)
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.recommend_list = []
            this.getTraverContentGroup()
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // -------------------------------游玩指南-----------------------------
    clickImageCard(val) {
      const newpage = this.$router.resolve({
        name: 'guide_group_detial',
        query: { guide_id: val.id },
      })
      window.open(newpage.href, '_blank')
    },
    clickAddGuide() {
      this.$prompt('输入指南名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          let post_item = {
            traver_id: this.traver_id,
            guide_title: value,
            dest: this.dest,
          }
          // 创建，并绑定
          this.$http
            .post('/traver/add_and_band_guide_group_to_traver', post_item)
            .then((res) => {
              if (res.data.errno == '0') {
                // 弹出提示
                this.$message({
                  type: 'success',
                  message: res.data.errmsg,
                })
                this.getTraverContentGuide()
                // 跳转
                const newpage = this.$router.resolve({
                  name: 'guide_group_detial',
                  query: { guide_id: res.data.guide_id },
                })
                window.open(newpage.href, '_blank')
              } else {
                // 弹出提示
                this.$message({
                  type: 'danger',
                  message: res.data.errmsg,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'danger',
            message: '取消添加',
          })
        })
    },
    // -------------------------------其他-----------------------------
    // 通过 traver_id 获取绑定的内容
    getBandContentList() {
      this.bandContentList = []
      this.$http
        .get(`/traver/get_band_content_list?traver_id=${this.traver_id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            let list = res.data.content
            // console.log(list)
            list.forEach((i) => {
              let item = {
                id: i.content_id,
                title: i.content_title,
                // title_mini: i.introduce,
                image: i.content_cover,
                // corner_name: i.dest,
                tag: i.tag_list,
                // update_time: i.update_time,
                type: i.content_class,
              }
              this.bandContentList.push(item)
            })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 获取迹点游玩指南
    getTraverContentGuide() {
      this.$http
        .get(`/traver/get_traver_guide_group?traver_id=${this.traver_id}`)
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            res.data.data.forEach((i) => {
              let guide_item = {
                image: i.guide_cover_image,
                id: i.guide_id,
                title: i.guide_name,
              }
              this.guidList.push(guide_item)
            })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 获取迹点周边推荐
    getTraverContentGroup() {
      this.$http
        .get(`/traver/get_recommend_near_traver?traver_id=${this.traver_id}`)
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            res.data.recommend.forEach((i) => {
              let item = {
                id: i.recommend_id,
                name: i.recommend_name,
                introduce: i.recommend_introduce,
                traver_point: i.traver_item_list,
              }
              this.recommend_list.push(item)
            })
          } else if (res.data.errno == '4002') {
          }
        })

      // 获取迹点绑定产品
    },
  },
}
</script>

<style>
.page-header-button {
  /* background-color: red; */
  font-size: 15px;
}
.el-card.card-header-style .el-card__header {
  background-color: #ff5421;
  color: white;
  padding: 5px 10px;
}
.header-product-title {
  padding: 5px;
}
.check-traver-point-band-location {
  position: absolute;
  display: block;
  margin: 0 auto;
  width: 100%;
  bottom: 0px;
  z-index: 1000;
}
</style>